module.exports = __webpack_public_path__ + "media/images/thumb-up-cbf71e7461b82f5cdfe47beaa2d5aeea.svg";